import { render, staticRenderFns } from "./OrgDashboard.vue?vue&type=template&id=3a3e14bc&scoped=true"
import script from "./OrgDashboard.vue?vue&type=script&lang=js"
export * from "./OrgDashboard.vue?vue&type=script&lang=js"
import style0 from "./OrgDashboard.vue?vue&type=style&index=0&id=3a3e14bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3e14bc",
  null
  
)

export default component.exports